<!--<div class="row">
    <div class="col-24">
        <h4><u>Section 1: Tell us about the applicant</u></h4>
    </div>
</div>-->
<div class="row" style="clear:none">
    <div class="col-16">
        <div class="bottom-20">
            <ValidatedRadioButtonGroup [label]="'Election Period'"
                                       [options]="electionPeriods"
                                       [disabled]="disabled"
                                       [selectedValue]="periodSelected"
                                       [radioGroupName]="'ElectionPeriods'"
                                       (onValueChange)="electionPeriodChanged($event)">
            </ValidatedRadioButtonGroup>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-16">
        <p class="election-option"><label>Election Option</label></p>
    </div>
</div>
<div *ngIf="!SEPDatePositionDown">
    <div class="row">
        <div class="col-16">
            <p class="election-option">{{selectedOption}}</p>
        </div>
    </div>
    <div class="row" *ngIf="isDateField">
        <div class="col-8">
            <div class="bottom-20" *ngIf="isDateField">
                <JQDatePicker [selectedDate]="sepDate"
                              (elementClicked)="sepDateChanged($event)">
                </JQDatePicker>
            </div>
        </div>
    </div>
</div>

<div class="row">
    <div class="col-16">
        <div class="bottom-20">
            <ValidatedRadioButtonGroup [label]="''"
                                       [options]="electionOprionsByPeriod"
                                       [selectedValue]="reasonCode"
                                       [radioGroupName]="'ElectionOptions'"
                                       [disabled]="disabled"
                                       (onValueChange)="electionOptionChanged($event)">
            </ValidatedRadioButtonGroup>
        </div>
    </div>
</div>
<div *ngIf="SEPDatePositionDown">
    <div class="row">
        <div class="col-16">
            <p class="election-option">{{selectedOption}}</p>
        </div>
    </div>
    <div class="row" *ngIf="isDateField">
        <div class="col-8">
            <div class="bottom-20" *ngIf="isDateField">
                <JQDatePicker [selectedDate]="sepDate"
                              (elementClicked)="sepDateChanged($event)">
                </JQDatePicker>
            </div>
        </div>
    </div>
</div>